import React from "react";
import PropTypes from "prop-types";

import { PageHeader } from "antd";
import { Segmented, Button, Dropdown, Divider, Space } from "antd";
import {
    AppstoreOutlined,
    BarsOutlined,
    CloudUploadOutlined,
    FolderAddOutlined,
    FileAddOutlined,
    DownOutlined,
} from "@ant-design/icons";

import Toolbar from "./toolbar";

const propTypes = {
    defaults: PropTypes.object.isRequired,

    view: PropTypes.oneOf(["grid", "list"]).isRequired,
    onChangeUploadMode: PropTypes.func.isRequired,
    onChangeView: PropTypes.func.isRequired,
    breadcrumbs: PropTypes.array,
    onChangeBreadcrumbs: PropTypes.func.isRequired,
    showNewFolderForm: PropTypes.func.isRequired,
    currentFolderObject: PropTypes.object.isRequired,

    onDownloadFolder: PropTypes.func.isRequired,

    allowZip: PropTypes.bool.isRequired,
    allowCreate: PropTypes.bool.isRequired,
    allowUpload: PropTypes.bool.isRequired,
};

const defaultProps = {
    breadcrumbs: [],
};

const items = [
    {
        label: "Upload files",
        key: "files",
        icon: <FileAddOutlined />,
    },
    {
        label: "Upload folder",
        key: "folders",
        icon: <FolderAddOutlined />,
    },
];

const Header = ({
    breadcrumbs,
    view,
    onChangeView,

    defaults,
    currentFolderObject,

    showNewFolderForm,
    onChangeBreadcrumbs,
    onChangeUploadMode,

    onDownloadFolder,

    allowZip,
    allowCreate,
    allowUpload,
}) => {
    const menuProps = {
        items,
        onClick: (e) => onChangeUploadMode(e.key),
    };

    const navigationOptions = [
        <Segmented
            key="view"
            size="small"
            value={view}
            onChange={onChangeView}
            options={[
                {
                    value: "grid",
                    icon: <AppstoreOutlined />,
                    label: "Grid",
                },
                {
                    value: "list",
                    icon: <BarsOutlined />,
                    label: "List",
                },
            ]}
        />,

        <Space key="options">
            {allowCreate && (
                <Button key="new-folder" size="small" type="default" onClick={showNewFolderForm}>
                    <FolderAddOutlined />
                    Folder
                </Button>
            )}
            {allowUpload && !defaults.upload_folder && (
                <Button size="small" type="primary" onClick={() => onChangeUploadMode("files")}>
                    <CloudUploadOutlined /> Upload
                </Button>
            )}
            {allowUpload && defaults.upload_folder && (
                <Dropdown.Button
                    size="small"
                    type="primary"
                    menu={menuProps}
                    placement="bottomRight"
                    onClick={() => onChangeUploadMode("files")}
                    icon={<DownOutlined />}
                >
                    <CloudUploadOutlined /> Upload
                </Dropdown.Button>
            )}
        </Space>,
    ];

    return (
        <PageHeader title="File Manager" style={{ paddingBottom: 0 }} extra={navigationOptions}>
            <Toolbar
                currentFolderObject={currentFolderObject}
                breadcrumbs={breadcrumbs}
                onChangeBreadcrumbs={onChangeBreadcrumbs}
                allowZip={allowZip}
                onDownloadFolder={onDownloadFolder}
            />
        </PageHeader>
    );
};

Header.propTypes = propTypes;
Header.defaultProps = defaultProps;
export default Header;
